// export const AUTH_SERVER_URL = 'https://agatho-prod.hertz.asiapac.io/auth';
// export const API_SERVER_URL = 'https://agatho-prod.hertz.asiapac.io/api';

const authServerURLS = {
  dev: "https://agatho-supergraph-dev.hertz.asiapac.io/auth",
  staging: "https://agatho-supergraph-staging.hertz.asiapac.io/auth",
  prod: "https://agatho-supergraph-prod.hertz.asiapac.io/auth"
};

const apiServerURLs = {
  dev: "https://agatho-supergraph-dev.hertz.asiapac.io/api",
  staging: "https://agatho-supergraph-staging.hertz.asiapac.io/api",
  prod: "https://agatho-supergraph-prod.hertz.asiapac.io/api"
};
const authExchangeURLs = {
  dev: "http://localhost:3000/dev/auth/exchange",
  staging: "http://localhost:3000/dev/auth/exchange",
  prod: "http://localhost:3000/dev/auth/exchange",
}
// Toggle the SSO login button and callback routes per environment
const ssoEnabled = {
  dev: false,
  staging: false,
  prod: false,
}
const cognitoAuthConfigs = {
  dev: {
    authority: "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_DWlFujQ9e",
    client_id: "6qr0p6e7mmmkeiv0efpe9un6k7",
    redirect_uri: "https://pnrmbstfcfqkh7s26kwn2wxihu0szijz.lambda-url.ap-southeast-2.on.aws/callback",
    response_type: "code",
    scope: "openid",
  },
  staging: {
    authority: "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_DWlFujQ9e",
    client_id: "4g5lljt7l66t2tp1im0mljuhmc",
    redirect_uri: "https://pnrmbstfcfqkh7s26kwn2wxihu0szijz.lambda-url.ap-southeast-2.on.aws/callback",
    response_type: "code",
    scope: "openid",
  },
  prod: {
    authority: "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_DWlFujQ9e",
    client_id: "4g5lljt7l66t2tp1im0mljuhmc",
    redirect_uri: "https://pnrmbstfcfqkh7s26kwn2wxihu0szijz.lambda-url.ap-southeast-2.on.aws/callback",
    response_type: "code",
    scope: "openid",
  }
}

export const AUTH_SERVER_URL = authServerURLS[process.env.ENDPOINT];
export const API_SERVER_URL =apiServerURLs[process.env.ENDPOINT];
//replace with api url when finished
export const STATIC_JSON = "https://p6kgn84ca2.execute-api.ap-southeast-2.amazonaws.com/dev/auth";
export const COGNITO_AUTH_CONFIG = cognitoAuthConfigs[process.env.ENDPOINT];
export const AUTH_EXCHANGE_SERVER_URL = authExchangeURLs[process.env.ENDPOINT];
export const SSO_ENABLED = ssoEnabled[process.env.ENDPOINT] === true;
